import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../grid/column.component";
import {AbstractColumnComponent} from "../../../grid/abstract-column.component";

@Component({
    selector: "wbo-url-link-column",
    templateUrl: "./url-link-column.component.html",
    styleUrls: ["./url-link-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => UrlLinkColumnComponent), multi: true}
    ]
})
export class UrlLinkColumnComponent extends AbstractColumnComponent {
    @Input() linkUrl: string;
    @Input() linkUrlResolver:  (dataItem: any) => string;

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * Invoked when the link is clicked
     * @param dataItem - row data
     */
    openUrl(dataItem: any) {
        const linkUrl: string = this.linkUrlResolver ? this.linkUrlResolver(dataItem) : (this.linkUrl || dataItem[this.field]);
        if (linkUrl) {
            window.open(linkUrl);
        }
    }
}
